import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "pss_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const publicApi = axios.create({ baseURL: API });
const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Public
export const getJobs = () => publicApi.get("/jobs").then((r) => r.data);
export const getCategories = () => publicApi.get("/categories").then((r) => r.data);
export const createMessage = (payload) => publicApi.post("/messages", payload).then((r) => r.data);

// Admin auth
export const adminLogin = (password) =>
  publicApi.post("/admin/login", { password }).then((r) => r.data);
export const adminVerify = () => adminApi.get("/admin/verify").then((r) => r.data);

// Admin messages
export const adminGetMessages = () => adminApi.get("/admin/messages").then((r) => r.data);
export const adminToggleRead = (id) =>
  adminApi.patch(`/admin/messages/${id}/read`).then((r) => r.data);
export const adminDeleteMessage = (id) =>
  adminApi.delete(`/admin/messages/${id}`).then((r) => r.data);

// Admin jobs
export const adminGetJobs = () => adminApi.get("/admin/jobs").then((r) => r.data);
export const adminCreateJob = (job) => adminApi.post("/admin/jobs", job).then((r) => r.data);
export const adminUpdateJob = (id, job) => adminApi.put(`/admin/jobs/${id}`, job).then((r) => r.data);
export const adminDeleteJob = (id) => adminApi.delete(`/admin/jobs/${id}`).then((r) => r.data);

// Admin categories
export const adminGetCategories = () => adminApi.get("/admin/categories").then((r) => r.data);
export const adminCreateCategory = (cat) => adminApi.post("/admin/categories", cat).then((r) => r.data);
export const adminUpdateCategory = (id, cat) => adminApi.put(`/admin/categories/${id}`, cat).then((r) => r.data);
export const adminDeleteCategory = (id) => adminApi.delete(`/admin/categories/${id}`).then((r) => r.data);
